import Entity from "../../../class/abstract/Entity";
import Store from "../../_account/Stores/Store";
import AutomaticDrawerLicense from "./AutomaticDrawerLicense";
import DrawerEventEntryController from "../../_legaldata/DrawerEventEntries/DrawerEventEntryController";
import AutomaticDrawerController from "./AutomaticDrawerController";

class AutomaticDrawer extends Entity {
    name = null;
    reference = null;
    brand = null;
    model = null;
    ipAddress = null;
    active = null;
    allowsDisconnectedAutomaticDrawer = null;
    allowsSimultaneousOperation = null;
    store_id = null;
    store = {};
    rescue_automatic_drawer_id = null;
    last_histo_author = null;
    licenses = [];
    loading = true;
    usable500 = null;
    usable200 = null;
    usable100 = null;
    usable50 = null;
    status = null;
    dateStatus = null;
    licensesString = "";
    brandResume = "";
    connectionResume = "";

    constructor(datas = {}) {
        super(datas);
        this.setAttributes(datas);
    }

    setAttributes(datas) {
        let keys = Object.keys(this);
        let key = "";
        let exceptKeys = ["licenses"];

        for(let i in keys) {
            key = keys[i];

            if (datas[key] !== undefined && !exceptKeys.includes(key)) {
                if(key === "store")
                    Reflect.set(this, key, new Store(datas[key]));
                else if(key === "rescue_drawer")
                    Reflect.set(this, key, new AutomaticDrawer(datas[key]));
                else
                    Reflect.set(this, key, datas[key]);
            }
        }

        if (datas.licenses !== undefined) {
            this.licenses = [];

            for (let item in datas.licenses)
                this.licenses.push(new AutomaticDrawerLicense(datas.licenses[item]));
        }

        this.defineBrandResume();
        this.defineConnectionResume();
        //this.defineLicenseString();
    }
    defineBrandResume() {
        if (this.brand === null || this.model === null)
            return;

        this.brandResume = this.brand + " - " + this.model;
    }
    defineConnectionResume() {
        this.connectionResume = "IP - " + this.ipAddress;
    }
    defineLicenseString() {
        if (this.licenses.length === 0)
            this.licensesString = "Aucune"
        else {
            for (let i in this.licenses) {
                if (this.licensesString.length > 0)
                    this.licensesString += ", "

                this.licensesString += this.licenses[i].name
            }
        }
    }
    getEvents(callback, identifier = null, nb = null, inventoryType = null) {
        const controller = new DrawerEventEntryController();
        controller._callback = callback;
        controller.index(identifier, nb, inventoryType, this.id);
    }
    explodeInventory(inventoryResponse) {
        let inventory = this.preBuildInventories();

        try {
            if (
                inventoryResponse["InventoryResponse"] === undefined
                || inventoryResponse["InventoryResponse"] === null
                || inventoryResponse["InventoryResponse"]["Cash"] === undefined
                || inventoryResponse["InventoryResponse"]["Cash"] === null)
                throw new Error();

            let cashes = inventoryResponse["InventoryResponse"]["Cash"];
            let cash, type;

            for (let i in cashes) {
                cash = cashes[i];
                if (cash["Denomination"] === undefined || cash["Denomination"] === null)
                    continue;

                type = cash["@type"] !== undefined ? cash["@type"] : cash["type"];

                switch (type) {
                    case "3":
                        inventory = this.fillInventory(inventory, "total", cash["Denomination"]);
                        break;
                    case "4":
                        inventory = this.fillInventory(inventory, "stacker", cash["Denomination"]);
                        break;
                    default: break;
                }
            }

            inventory = this.fillCassetteInventory(inventory);
        }
        catch (e) {}

        return inventory;
    }
    preBuildInventories() {
        let inventory = {
            "stacker": { "total": 0 },
            "cassette": { "total": 0 },
            "total": { "total": 0 }
        };

        for (let key in AutomaticDrawerController._denominations) {
            let denom = AutomaticDrawerController._denominations[key];

            inventory["stacker"][denom.fv] = {
                devid: denom.devid,
                fv: denom.fv,
                value: denom.value,
                euro: denom.euro,
                piece: 0,
                status: 0
            }
            inventory["cassette"][denom.fv] = {
                devid: denom.devid,
                fv: denom.fv,
                value: denom.value,
                euro: denom.euro,
                piece: 0,
                status: 0
            }
            inventory["total"][denom.fv] = {
                devid: denom.devid,
                fv: denom.fv,
                value: denom.value,
                euro: denom.euro,
                piece: 0,
                status: 0
            }
        }

        return inventory;
    }
    fillInventory(inventory, type, datas) {
        for (let i in datas) {
            let denominationData = datas[i];
            let fv = null;

            if (denominationData["fv"] !== undefined)
                fv = denominationData["fv"];
            else if (denominationData["@fv"] !== undefined)
                fv = denominationData["@fv"];

            if (fv == null) continue;

            let denomination = AutomaticDrawerController._denominations.find(_ => _.fv === fv);
            if (denomination === undefined) continue;

            if (inventory[type][fv] === undefined) {
                inventory[type][fv] = {
                    devid: denomination.devid,
                    fv: fv,
                    value: denomination.value,
                    euro: denomination.euro,
                    piece: parseInt(denominationData["Piece"]),
                    status: parseInt(denominationData["Status"])
                };
            }
            else {
                inventory[type][fv].piece = parseInt(denominationData["Piece"]);
                inventory[type][fv].status = parseInt(denominationData["Status"]);
            }

            inventory[type]["total"] += denomination.value * inventory[type][fv].piece;
        }

        return inventory;
    }
    fillCassetteInventory(inventory) {
        for (let i in AutomaticDrawerController._denominations) {
            let denomination = AutomaticDrawerController._denominations[i];

            let inStacker = inventory["stacker"][denomination.fv];
            let inTotal = inventory["total"][denomination.fv];

            if (inStacker === undefined || inTotal === undefined) continue;

            if (inventory["cassette"][denomination.fv] === undefined) {
                inventory["cassette"][denomination.fv] = {
                    devid: denomination.devid,
                    fv: denomination.fv,
                    value: denomination.value,
                    euro: denomination.euro,
                    piece: inTotal.piece - inStacker.piece,
                    status: 0
                };
            }
            else {
                inventory["cassette"][denomination.fv].piece = inTotal.piece - inStacker.piece;
            }

            inventory["cassette"]["total"] += denomination.value * inventory["cassette"][denomination.fv].piece;
        }

        return inventory;
    }
}

export default AutomaticDrawer;
